import { render } from "./ExpenseModal.vue?vue&type=template&id=20393bb8&scoped=true&ts=true"
import script from "./ExpenseModal.vue?vue&type=script&lang=ts"
export * from "./ExpenseModal.vue?vue&type=script&lang=ts"

import "./ExpenseModal.vue?vue&type=style&index=0&id=20393bb8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20393bb8"]])

export default __exports__